<template>
  <Tenant/>
</template>

<script>
import Tenant from "./visitor.vue";

export default {
  components: {
    Tenant,
  },
}
</script>

<style scoped lang="less">

</style>
